export type CompanyLocation = {
  zipCity: string;
  street: string;
  phone: string;
  email?: string;
};

export const COMPANY = {
  name: 'BauwerkPlus',
  tagline: 'Ihr Partner für nachhaltige Betonsanierung und Oberflächenpflege',
  address: 'Treffling 75b',
  city: '9871 Seeboden am Millstätter See',
  phone: '+43 699 141414 00',
  email: 'technik@bauwerkplus.at',
  logoUrl: 'https://image-linker--hoferdruck9871.replit.app/objects/uploads/dab44326-1652-4af8-b5c7-a3a7eeb1aa3f',
  logoUrl2: 'https://image-linker--hoferdruck9871.replit.app/objects/uploads/d377edc0-d3a9-43c3-b73a-4f07cc036860',
  headerLogoUrl: 'https://image-linker--hoferdruck9871.replit.app/objects/uploads/16e40dfb-b3f5-4384-8229-ed55bd9c9797',
  locations: [
    {
      zipCity: '9871 Seeboden',
      street: 'Treffling 75b',
      phone: '+43 699 141414 00',
      email: 'technik@bauwerkplus.at',
    },
    {
      zipCity: '9815 Kolbnitz',
      street: 'Unterkolbnitz 71',
      phone: '+43 676 65101637',
    },
  ] as CompanyLocation[],
} as const;

export function formatLocationLine(loc: CompanyLocation): string {
  const parts = [loc.zipCity, loc.street, loc.phone];
  if (loc.email) parts.push(loc.email);
  return parts.join(' · ');
}

export function getCompanyContactLines(): string[] {
  return COMPANY.locations.map(formatLocationLine);
}

export function generateQuoteNumber(): string {
  const year = new Date().getFullYear();
  const num = String(Math.floor(Math.random() * 9000) + 1000);
  return `BP-${year}-${num}`;
}
